import { Stack } from '@mui/material';
import { memo } from 'react';
import { useAppSelector } from '../../store/hooks';
import { SnackbarStackItem } from './SnackbarStackItem';
import { snackbarStackStyles } from './styles';

const SnackbarStackComponent: React.FC = () => {
  const snackbars = useAppSelector((state) => state.snackbar.snackbars);
  return (
    <Stack spacing={2} sx={snackbarStackStyles.stack}>
      {snackbars.map((snackbar) => (
        <SnackbarStackItem key={snackbar.id} snackbar={snackbar} />
      ))}
    </Stack>
  );
};

export const SnackbarStack = memo(SnackbarStackComponent);
